
import { useCostsActions, useCostsContext } from "@contexts/costs";
import { indexes, itemGroups } from "./components/utils";
import { useEffect, useState } from "react";

const defaultUnitValue = {
  paramId: '',
  value: 0,
  reference: '',
  date: '',
  _id: 0,
}

const UnitValues = () => {
  const { getUnitValues, updateUnitValues, getParams, deleteCostItem } = useCostsActions();
  const { currentBuilding } = useCostsContext();
  const [unitValue, setUnitValue] = useState(defaultUnitValue)
  const [unitValues, setUnitValues] = useState([])
  const [params, setParams] = useState([])

  const list = async () => {
    const res = await getParams('')
    setParams(res.res)

    const un = await getUnitValues()
    setUnitValues(un.res)
  }

  useEffect(() => {
    list()
  }, [])

  const handleSend = async () => {
    const res = await updateUnitValues(unitValue)
    setUnitValue(defaultUnitValue)

    if (res.status === 200) {
      setUnitValues(prev => [...prev, unitValue])
    }
  }

  const handleEdit = (event) => {
    event.preventDefault();

    setUnitValue(prev => ({
      ...prev,
      [event.target.name]: event.target.value
    }));
  }

  const handleChooseUnitValue = (i) => {
    setUnitValue(unitValues[i])
    window.scrollTo(0, 0);
  }

  const reset = () => {
    setUnitValue(defaultParam)
  }

  const handleDelete = async (i) => {
    const res = await deleteCostItem(unitValues[i]._id, 'unitValues')

    if (res.status === 200) {
      const newItems = unitValues.filter((item, index) => index !== i)
      setUnitValues(newItems)
    }
  }

  return <div className="costs">
    <h2>Valores Unitários</h2>
    <div className="grid columns-5-tablet gap-8 margin-bottom-16">
      <div>
        <label>Parâmetro</label>
        <select name="paramId" value={unitValue.paramId} onChange={handleEdit}>
          <option disabled value="">Selecione um parâmetro</option>
          {params.map(i => {
            return <option key={i._id} value={i.paramId}>{i.name}</option>
          })}
        </select>
      </div>
      <div>
        <label>Valor</label>
        <input type="number" onChange={handleEdit} value={unitValue.value} name="value" />
      </div>
      <div>
        <label>Referência</label>
        <input type="text" onChange={handleEdit} value={unitValue.reference} name="reference" />
      </div>
      <div>
        <label>Data</label>
        <input type="date" onChange={handleEdit} value={unitValue.date} name="date" />
      </div>
      <button onClick={handleSend} className="button button-accent">Enviar</button>
    </div>
    <div className="margin-top-16">
      {unitValues.length > 0 && unitValues.map((i, index) => {
        return <div key={i.name} className="grid columns-8-tablet gap-8 margin-bottom-4 checklist-row">
          <div className="column-span-3">
            <p className="accordion-label">Parâmetro</p>
            <p className="accordion-value">{i.paramId}</p>
          </div>
          <div>
            <p className="accordion-label">Valor</p>
            <p className="accordion-value">{i.value}</p>
          </div>
          <div>
            <p className="accordion-label">Referência</p>
            <p className="accordion-value">{i.reference}</p>
          </div>
          <div>
            <p className="accordion-label">Data</p>
            <p className="accordion-value">{i.date}</p>
          </div>
          <div className="flex gap-4 column-span-2 justify-content-end">
            <button className="button button-secondary" onClick={() => handleChooseUnitValue(index)}>Editar</button>
            <button className="button button-error" onClick={() => handleDelete(index)}>Deletar</button>

          </div>
        </div>
      })}
    </div>
  </div>
}

export default UnitValues